module.exports = __webpack_public_path__ + "static/media/banner-home-3.e48182b6.jpg";